<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 试卷管理
        </span>
        <normalNav :parent="self">
          <button class="GreenSmBtn" @click="$refs.testDialog.toAddNew()">新增</button>
        </normalNav>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl"></searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <easyTable apiUrl="operation/examPaper/page" :parent="self" :config="config" :other="other" ref="table_jsgl">
            <template slot="last">
              <el-table-column prop="status" show-overflow-tooltip label="状态" align="center" :formatter="testState"></el-table-column>
            </template>
            <template slot="last">
              <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
            </template>
            <template slot="last">
              <el-table-column label="操作" width="320" align="left">
                <template slot-scope="scope">
                  <el-link icon="iconfont iconcheck1" type="text" size="small" @click="changeStatus(scope.$index, scope.row)" v-if="scope.row.status == 0">发布</el-link>
                  <el-link icon="iconfont icontingyong" type="text" size="small" @click="changeStatus(scope.$index, scope.row)" v-if="scope.row.status == 1">下线</el-link>
                  <el-link icon="iconfont iconedit" type="text" size="small" @click="editDialog(scope.row)">编辑</el-link>
                  <el-link icon="iconfont iconwhole" type="text" size="small" @click="getTestDetail(scope.$index, scope.row)">详情</el-link>
                  <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)" v-if="scope.row.status == 0">删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <test-dialog ref="testDialog"></test-dialog>
    <test-detail ref="testDetail" :testData='testData'></test-detail>
    <editPaperOrder ref="editPaperOrder"></editPaperOrder>
  </div>
</template>

<script>
import { dt, obj2urlsp } from 'utils'

export default {
  data() {
    return {
      form_jsgl: {},
      items: [
        {
          type: 'input',
          prop: 'name',
          label: '试卷名称',
          placeholder: '请输入试卷名称',
          option: {}
        }
      ],
      key: '',
      title: '',
      tabName: 'jsgl',
      showTable: true,
      other: {},
      testData: [],
      seefrom: {}
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'name',
          label: '试卷名称'
        },
        {
          prop: 'totalScore',
          label: '总分'
        }
      ]
    },
    dt() {
      return dt.map(({ label }) => label)
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    testDialog: () => import('./testDialog'),
    easyTable: () => import('public/easyTable'),
    searchForm: () => import('public/searchForm'),
    testDetail: () => import('./testDetail'),
    editPaperOrder: () => import('./editPaperOrder')
  },
  methods: {
    reset_jsgl(fn) {
      fn()
      this.form_jsgl = {}
    },
    search_jsgl(fn) {
      fn()
    },
    // 试卷详情
    getTestDetail(index, row) {
      this.$axiosget(`operation/examPaper/detail/${row.id}`).then((res) => {
        this.testData = res.data.data
        this.$refs.testDetail.open()
      })
    },
    testState(row, column) {
      return row.status == 0 ? '待发布' : '发布'
    },
    changeStatus(index, row) {
      let msg, status
      if (row.status == 0) {
        msg = '发布'
        status = 1
      } else {
        msg = '待发布'
        status = 0
      }
      this.$confirm(`试卷状态改为${msg}`, '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axiosput(
            `operation/examPaper/status?id=${row.id}&status=${status}`
          ).then((res) => {
            if (res.data.status == '10000') {
              this.$message.success('操作成功!')
              this.$refs.table_jsgl.getData()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    editDialog(row) {
      if (row.status == 0) {
        this.$refs.testDialog.toEdit(row)
      } else {
        this.$refs.editPaperOrder.toAddNew(row)
      }
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axiosput(
            `operation/examPaper/status?id=${row.id}&status=2`
          ).then((res) => {
            if (res.data.status == '10000') {
              this.$message.success('删除成功')
              this.$refs.table_jsgl.getData()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.OrangeSmBtn {
  background: #21b8a1;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exam/testPaper/index.vue